import React from 'react'
import { useIntl } from 'react-intl'

import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Caption from 'LuxKit/Typography/Caption'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'

interface Props {
  startLocation?: string | null
  typeOfExperience?: string
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationWithTypeOfExperience({
  startLocation,
  typeOfExperience,
  size = 'large',
}: Props) {
  const intl = useIntl()
  const sep = intl.formatMessage(middleDotSeparatorMessage)
  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      {startLocation}
      {typeOfExperience && (
        <Caption as="span" variant={size} colour="neutral-two">
          {` ${sep} ${typeOfExperience}`}
        </Caption>
      )}
    </CaptionTextBlock>
  )
}

export default BookmarkLocationWithTypeOfExperience
